import { faDollarSign } from '@fortawesome/pro-regular-svg-icons';
import { faGift, faHeart, faTicket } from '@fortawesome/pro-solid-svg-icons';
import { TransactionLineItem } from 'types/domain';

const getProductIcon = (lineItem: TransactionLineItem) => {
    if (!!lineItem.item?.auction_id) {
        return faGift;
    }

    if (lineItem?.subtype === 'donation') {
        return faHeart;
    }

    if (lineItem?.subtype === 'ticket') {
        return faTicket;
    }

    return faDollarSign;
};

export { getProductIcon };
